// This file is generated.
export const version = '2.3.0';
//# sourceMappingURL=version.js.map